export const FETCH_CLAIMS_QUESTION_LENGTH = 'FETCH_CLAIMS_QUESTION_LENGTH';
export const FETCH_CLAIMS_QUESTION_SUCCESS = 'FETCH_CLAIMS_QUESTION_SUCCESS';
export const FETCH_CLAIMS_QUESTION_FAILURE = 'FETCH_CLAIMS_QUESTION_FAILURE';

export const STEPPER_INIT = 'STEPPER_INIT';
export const STEPPER_NEXT = 'STEPPER_NEXT';
export const STEPPER_PREV = 'STEPPER_PREV';
export const STEPPER_ACTIVE = 'STEPPER_ACTIVE';

export const INPUT_CHANGE = 'INPUT_CHANGE';

export const PROCESSING_CLAIM = 'PROCESSING_CLAIM';
export const SEND_CLAIMS_DATA_SUCCESS = 'SEND_CLAIMS_DATA_SUCCESS';
export const SEND_CLAIMS_DATA_FAILURE = 'SEND_CLAIMS_DATA_FAILURE';

export const VALID_CATEGORY_CHECK = 'VALID_CATEGORY_CHECK';

export const FETCH_CLAIMS_ATTACHMENT_CONFIG_SUCCESS = 'FETCH_CLAIMS_ATTACHMENT_CONFIG_SUCCESS';
export const FETCH_CLAIMS_ATTACHMENT_CONFIG_FAILURE = 'FETCH_CLAIMS_ATTACHMENT_CONFIG_FAILURE';
export const ATTACHMENT_DELETE_SUCCESS = 'ATTACHMENT_DELETE_SUCCESS';
export const ATTACHMENT_DELETE_FAILURE = 'ATTACHMENT_DELETE_FAILURE'
export const ATTACHMENT_UPLOAD_SUCCESS = 'ATTACHMENT_UPLOAD_SUCCESS';
export const ATTACHMENT_UPLOAD_FAILURE = 'ATTACHMENT_UPLOAD_FAILURE';

export const DATA_FORM_DIALOG_OPEN = 'DATA_FORM_DIALOG_OPEN';
export const REQUEST_DATA_FORM_DIALOG_CLOSE = 'REQUEST_DATA_FORM_DIALOG_CLOSE';
export const ALERT_DIALOG_OPEN = 'ALERT_DIALOG_OPEN';
export const REQUEST_ALERT_DIALOG_CLOSE = 'REQUEST_ALERT_DIALOG_CLOSE';
export const REGION_ACQUISITION_FAILURE = 'REGION_ACQUISITION_FAILURE';
export const REGION_SELECTED = 'REGION_SELECTED';
export const REGION_ACQUIRED = 'REGION_ACQUIRED';
export const COMPANY_INFO_ACQUIRED = 'COMPANY_INFO_ACQUIRED';
export const COMPANY_INFO_ACQUISITION_FAILURE = 'COMPANY_INFO_ACQUISITION_FAILURE';
export const REGION_SELECTED_ACQUIRED = 'REGION_SELECTED_ACQUIRED';
export const REGION_SELECTED_ACQUISITION_FAILURE = 'REGION_SELECTED_ACQUISITION_FAILURE';


// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js